import React from "react";
import { Shield } from "lucide-react";
import { GrcCard } from "./shared";
import { Badge } from "@/components/ui/badge";

export const MaturityCard = ({ level, label, band, penaltyText }) => (
  <GrcCard
    title="Maturity Level"
    info="Maturity band comes directly from the App A assessment (single source of truth — never re-derived here)."
    infoTestId="info-maturity"
    testId="card-maturity"
  >
    <div className="flex flex-col items-center gap-2 py-2">
      <div className="relative">
        <Shield size={72} strokeWidth={1.5} className="text-[#388E3C]" />
        <span
          data-testid="maturity-level-value"
          className="absolute inset-0 flex items-center justify-center text-xl font-bold text-[#003366] pt-[-4px]"
        >
          {level != null ? `L${level}` : "—"}
        </span>
      </div>
      <div data-testid="maturity-label" className="text-lg font-semibold text-[#388E3C]">
        {label || "—"}
      </div>
      {band && (
        <Badge variant="secondary" className="bg-[#388E3C]/10 text-[#388E3C] hover:bg-[#388E3C]/10" data-testid="maturity-band-badge">
          {band}
        </Badge>
      )}
      {penaltyText && <div className="text-xs text-slate-500 text-center">{penaltyText}</div>}
    </div>
  </GrcCard>
);
